import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';

import AppleBadge from '../../../../assets/img/store-badges/apple_US.svg';
import GoogleBadge from '../../../../assets/img/store-badges/google_US.png';
import { UpgradeSubscriptionSlide } from './UpgradeSubscriptionSlide';

interface UpgradeSubscriptionWebDialogProps {
  onClose: () => void;
}

export const UpgradeSubscriptionWebDialog = ({ onClose }: UpgradeSubscriptionWebDialogProps) => {
  return (
    <UpgradeSubscriptionSlide
      children={
        <Grid style={{ display: `flex`, justifyContent: `center`, alignItems: `center`, flexDirection: `column` }}>
          <Grid
            item
            style={{
              width: `100%`,
              // backgroundColor: `black`,
              borderRadius: `10px`,
              display: `flex`,
              justifyContent: `center`,
            }}
            onClick={() => (window.location.href = `https://play.google.com/store/apps/details?id=com.routal.drivers`)}
          >
            <img src={GoogleBadge} style={{ height: `52px` }} alt="Get it on Google Play" />
          </Grid>
          <VSpacer small />
          <Grid
            item
            style={{
              width: `100%`,
              // backgroundColor: `black`,
              borderRadius: `10px`,
              display: `flex`,
              justifyContent: `center`,
            }}
            onClick={() => (window.location.href = `https://apps.apple.com/us/app/routal/id1581440136`)}
          >
            <img src={AppleBadge} style={{ height: `52px` }} alt="Download on the App Store" />
          </Grid>
        </Grid>
      }
      onClose={onClose}
      openSlide={true}
      titleId={`drivers.subscription_upgrade_dialog_web.title`}
      subtitleId={`drivers.subscription_upgrade_dialog_web.subtitle`}
    />
  );
};
